// extracted by mini-css-extract-plugin
module.exports = {"container":"Cf","disabled":"Df","bgBlack":"Ef","content":"Ff","countdown":"Gf","topCaption":"Hf","topHeading":"If","heading":"Jf","copy":"Kf"};